import axios from "axios";

const baseUrl = document.body.dataset['app_base_url'];
const axiosInstance = axios.create({
  baseURL: baseUrl,
});

// axiosInstance.baseURL = "http://localhost/carlos-saas";

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) =>
    Promise.reject(
      (error.response && error.response.data) || "Something went wrong"
    )
);

export default axiosInstance;
